import { render, staticRenderFns } from "./VerificationPoint.vue?vue&type=template&id=507cd2f1&scoped=true"
import script from "./VerificationPoint.vue?vue&type=script&lang=js"
export * from "./VerificationPoint.vue?vue&type=script&lang=js"
import style0 from "./VerificationPoint.vue?vue&type=style&index=0&id=507cd2f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507cd2f1",
  null
  
)

export default component.exports